import PropTypes from "prop-types";

import { Grid, Paper, Typography } from "@mui/material";

import { formatDate } from "@/features/shared";

export const GeneralInformationSection = ({ journalVoucher }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Umum</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Transaksi
          </Typography>
          <Typography variant="body1">
            {formatDate(journalVoucher.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Outlet
          </Typography>
          <Typography variant="body1">
            {journalVoucher.outlet?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Catatan
          </Typography>
          <Typography variant="body1">{journalVoucher.note || "-"}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  journalVoucher: PropTypes.object.isRequired,
};
